<template>
	<tr :class="{ disabled }">
		<td v-for="field in parsed" :key="field.field" :class="{ collapse: field.collapse }">
			{{ field.value }}
		</td>
		<td class="min"><slot /></td>
	</tr>
</template>

<script>
import { DateTime } from 'luxon'
const isDate = string => DateTime.fromISO(string).isValid

export default {
	name: 'APIListRow',
	props: {
		data: Array,
		disabled: Boolean,
	},
	computed: {
		parsed() {
			return this.data.map(field => ({
				...field,
				value: this.parseValue(field.value),
			}))
		},
	},
	methods: {
		parseValue(value) {
			if (isDate(value)) {
				// Parse dates to human-readable strings
				return DateTime.fromISO(value).toLocaleString(DateTime.DATETIME_SHORT)
			} else {
				return value
			}
		},
	},
}
</script>
